export default __webpack_public_path__ + "static/media/overview.5b974935.svg";